import {kSystemIcons} from "../../../constants/icons";
import {kVoidTexts} from "../../../constants/texts";

export default function CoursesLevelAsVoid() {
    // Used in CoursesLevelAsList to display empty
    // LevelAs list

    // BUILD
    return (
        <div className={"w-full flex flex-col justify-center items-center px-48"}>
            <i className={`material-icons text-[24px] lg:text-[32px] text-greyLight9`}>
                {kSystemIcons.support}
            </i>
            <span className={"text-center font-medium text-[16px] text-greyLight9 mt-8"}>
                {kVoidTexts.levelAsList}
            </span>
        </div>
    );
}